import { ChecklistItemNoteSectionRecord } from "models/view-models/checklist-item-notes/checklist-item-note-section-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface ChecklistItemNoteSectionResourcePathParams {
    id: number;
}

export interface ChecklistItemNoteSectionCreateParams {
    checklistItemNoteId: number;
    sectionId: number;
}

const resourceType = ChecklistItemNoteSectionRecord;
const baseEndpoint = "checklistitemnotesection";
const resourceEndpoint = "checklistitemnotesection/:id";

const ChecklistItemNoteSectionService = {
    useCreate: ServiceHookFactory.useCreateFromPostParams<
        ChecklistItemNoteSectionRecord,
        ChecklistItemNoteSectionCreateParams
    >(resourceType, baseEndpoint),
    useDelete:
        ServiceHookFactory.useDelete<ChecklistItemNoteSectionResourcePathParams>(
            resourceEndpoint
        ),
};

export default ChecklistItemNoteSectionService;
